/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevResponseMapStringObject
 */
export interface DevResponseMapStringObject {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DevResponseMapStringObject
     */
    data?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof DevResponseMapStringObject
     */
    message?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof DevResponseMapStringObject
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof DevResponseMapStringObject
     */
    error?: string;
}

/**
 * Check if a given object implements the DevResponseMapStringObject interface.
 */
export function instanceOfDevResponseMapStringObject(value: object): value is DevResponseMapStringObject {
    return true;
}

export function DevResponseMapStringObjectFromJSON(json: any): DevResponseMapStringObject {
    return DevResponseMapStringObjectFromJSONTyped(json, false);
}

export function DevResponseMapStringObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevResponseMapStringObject {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
        'message': json['message'] == null ? undefined : json['message'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function DevResponseMapStringObjectToJSON(json: any): DevResponseMapStringObject {
    return DevResponseMapStringObjectToJSONTyped(json, false);
}

export function DevResponseMapStringObjectToJSONTyped(value?: DevResponseMapStringObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'message': value['message'],
        'success': value['success'],
        'error': value['error'],
    };
}

